import { DomainVersion } from "@/models";
import { setDisplayedItems } from "@/utils/setDisplayedItems";
import { list, listAll } from "@/utils/factoryRest";
import { DomainVersionApi, PublicDomainVersionApi } from "@socotec.io/certipers-back-sdk";
import configs from "@/setup/openApiConfig";
import { defineStore } from "pinia";
import { useRepo } from "pinia-orm";

const domainVersionRepo = useRepo(DomainVersion);
const domainVersionApi = new DomainVersionApi(configs.certipersBackConfig);
const publicDomainVersionApi = new PublicDomainVersionApi(configs.certipersBackConfig);

const formatDomainVersionData = (domainVersionData) => {
  return {
    ...domainVersionData,
    uuid: domainVersionData.uuid,
    domainUuid: domainVersionData.domain,
  };
};

export const useDomainVersionStore = defineStore("domainVersion", {
  state: () => ({
    domainVersionsCount: 0,
  }),

  actions: {
    fetchPublicDomainVersions: list({
      ModelRepo: domainVersionRepo,
      restListMethod: publicDomainVersionApi.list.bind(publicDomainVersionApi),
      handleResponseData: ({ results }) => {
        return results.map(formatDomainVersionData);
      },
      onItemsInserted: (responseData) => {
        useDomainVersionStore().setDomainVersionsCount(responseData.count);
        setDisplayedItems(domainVersionRepo, responseData.results);
      },
    }),

    async fetchAllDomainVersions(filters = {}) {
      const response = await listAll(domainVersionApi.list.bind(domainVersionApi), filters);

      this.setDomainVersionsCount(response.length);
      const formatedResponse = response.map(formatDomainVersionData);
      const domainVersions = domainVersionRepo.save(formatedResponse);
      setDisplayedItems(domainVersionRepo, response);

      return domainVersions;
    },

    fetchDomainVersions: list({
      ModelRepo: domainVersionRepo,
      restListMethod: domainVersionApi.list.bind(domainVersionApi),
      handleResponseData: ({ results }) => {
        return results.map(formatDomainVersionData);
      },
      onItemsInserted: (responseData) => {
        setDisplayedItems(domainVersionRepo, responseData.results);
        useDomainVersionStore().setDomainVersionsCount(responseData.count);
      },
    }),

    async partialUpdateDomainVersion({ uuid, ...changes }) {
      const response = await domainVersionApi.partialUpdate({
        uuid,
        patchedDomainVersionRequest: changes,
      });
      domainVersionRepo.save(formatDomainVersionData(response));
    },

    setDomainVersionsCount(count) {
      this.domainVersionsCount = count;
    },
  },

  getters: { getDomainVersionsCount: (state) => state.domainVersionsCount },
});
